import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export const LoginAPI = async (values) => {
  try {
     console.log("working")
    const apiUrl = process.env.REACT_APP_API_URL;
    if (!apiUrl) {
      throw new Error("API URL is not defined!");
    }
    const res = await axios.post(`${apiUrl}/api/loginData`, values);
    console.log("response", res)
    if (res.status === 200) {
      localStorage.setItem("token", res.data.token);

      toast.success(res.data);
      return res;
    } else if (res.status === 401) {
      console.log(res?.data?.error)
      toast.error(res?.data?.error)
    } else {
      toast.error(res?.data?.error)
    }
  } catch (error) {
    console.log(error.message, "error")
    toast.error(error.message);
    return error.message;
  }
};  
